import { gql } from "@apollo/client";

export const generateRoom = gql`
  mutation generateRoom($campaignId: ID!) {
    generateRoom(campaignId: $campaignId) {
      id
    }
  }
`;
